// extracted by mini-css-extract-plugin
module.exports = {"imgBackground":"image-formatter_imgBackground__5VhLw","img":"image-formatter_img__Cyh3O"};